var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.25C20.8789 8.25 22 9.37109 22 10.75V19.5C22 20.8789 20.8789 22 19.5 22H4.5C3.11914 22 2 20.8789 2 19.5V10.75C2 9.37109 3.11914 8.25 4.5 8.25H19.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.1875 7H4.8125C4.29492 7 3.875 6.58203 3.875 6.0625C3.875 5.54492 4.29492 5.125 4.8125 5.125H19.1875C19.707 5.125 20.125 5.54492 20.125 6.0625C20.125 6.58203 19.707 7 19.1875 7ZM17.3125 3.875H6.6875C6.16797 3.875 5.75 3.45508 5.75 2.9375C5.75 2.41992 6.16797 2 6.6875 2H17.3125C17.832 2 18.25 2.41992 18.25 2.9375C18.25 3.45508 17.832 3.875 17.3125 3.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjects);
export default __webpack_public_path__ + "static/media/icon-projects.edda3718efe2e6f90df6c820e521617f.svg";
export { ForwardRef as ReactComponent };